<div
  class="cx-anonymous-consent-dialog"
  [cxFocus]="focusConfig"
  (esc)="close('Escape clicked')"
  >
  <div class="cx-dialog-content">
    @if (loading$ | async) {
      <div>
        <cx-spinner></cx-spinner>
      </div>
    } @else {
      <div
        role="status"
        [attr.aria-label]="'common.loaded' | cxTranslate"
      ></div>
      <div class="cx-dialog-header">
        <h3>
          {{ 'anonymousConsents.dialog.title' | cxTranslate }}
        </h3>
        <button
          type="button"
          class="close"
          [attr.aria-label]="'common.close' | cxTranslate"
          (click)="close('Cross click')"
          >
          <span aria-hidden="true">
            <cx-icon [type]="iconTypes.CLOSE"></cx-icon>
          </span>
        </button>
      </div>
      <!-- Separator -->
      @if (showLegalDescription) {
        <div class="cx-dialog-description">
          {{ 'anonymousConsents.dialog.legalDescription' | cxTranslate }}
          <div
            class="cx-dialog-separator col-sm-12 d-xs-block d-sm-block d-md-none"
          ></div>
        </div>
      }
      <!-- Actions -->
      <div class="cx-dialog-buttons">
        <a tabindex="0" class="btn-link cx-action-link" (click)="rejectAll()">{{
          'anonymousConsents.dialog.clearAll' | cxTranslate
        }}</a>
        <a tabindex="0" class="btn-link cx-action-link" (click)="allowAll()">{{
          'anonymousConsents.dialog.selectAll' | cxTranslate
        }}</a>
      </div>
      <!-- Modal Body -->
      @if (templates$ | async; as templates) {
        <div class="cx-dialog-body">
          @if (consents$ | async; as consents) {
            @for (template of templates; track template) {
              <div
                class="cx-dialog-row col-sm-12 col-md-6"
                >
                <app-efa-consent-management-form
                  [consentTemplate]="template"
                  [requiredConsents]="requiredConsents"
                  [consent]="getCorrespondingConsent(template, consents)"
                  (consentChanged)="onConsentChange($event)"
                ></app-efa-consent-management-form>
              </div>
            }
          }
        </div>
      }
    }
  </div>
</div>
